import React, { useState, useEffect } from 'react';
import { Colors } from '../../../styles';
import { DiscountStore } from '../../../stores/discount/discountStore';

export const DiscountConfig = () => {
  const [code, setCode] = useState('');
  const [discount, setDiscount] = useState('');
  const [expires, setExpires] = useState(true);
  const [discounts, setDiscounts] = useState<any[]>([]);

  useEffect(() => {
    DiscountStore().get().then((data) => setDiscounts(data));
  }, []);

  const handleCreate = async () => {
    if (!code || !discount) return;
    await DiscountStore().create(code, Number(discount), expires);
    setCode('');
    setDiscount('');
    setExpires(true);
    const data = await DiscountStore().get();
    setDiscounts(data);
  };

  const handleDelete = async (id: number) => {
    await DiscountStore().delete(id);
    const data = await DiscountStore().get();
    setDiscounts(data);
  };

  return (
    <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg h-auto rounded-2xl w-full md:w-800 p-6 m-3 shadow-md border-color box-border">
      <div className="flex justify-between items-center mb-4">
        <p className="text-xl font-bold">Cupons de Desconto</p>
      </div>

      <div className="flex flex-col md:flex-row gap-4 mb-4">
        <input 
          type="text" 
          value={code} 
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="Código (Ex: LIMPEZA)"
          className="border p-2 rounded flex-1 dark:bg-gray-800 dark:border-gray-600"
        />
        <input 
          type="number" 
          value={discount} 
          onChange={(e) => setDiscount(e.target.value)}
          placeholder="%(Ex: 10)"
          className="border p-2 rounded w-32 dark:bg-gray-800 dark:border-gray-600"
        />
        <select 
          value={expires ? 'true' : 'false'}
          onChange={(e) => setExpires(e.target.value === 'true')}
          className="border p-2 rounded dark:bg-gray-800 dark:border-gray-600"
        >
          <option value="true">Expira em 24h</option>
          <option value="false">Não Expira</option>
        </select>
        <button 
          onClick={handleCreate}
          className="p-2 rounded text-white"
          style={{ backgroundColor: Colors.primary }}
        >
          Adicionar
        </button>
      </div>

      <div>
        {discounts
          .sort((a, b) => {
            const getExpiredStatus = (d: any) => {
              if (d.expires === false) return false;
              if (!d.createdAt) return true;
              const isoString = String(d.createdAt).includes('Z') 
                ? String(d.createdAt) 
                : String(d.createdAt).replace(' ', 'T') + 'Z';
              const diffHours = (new Date().getTime() - new Date(isoString).getTime()) / 3600000;
              return diffHours > 24;
            };
            const aExpired = getExpiredStatus(a);
            const bExpired = getExpiredStatus(b);
            if (aExpired !== bExpired) return aExpired ? 1 : -1;
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
          })
          .map((d: any) => {
            let isExpired = false;
            if (d.expires === false) {
              isExpired = false;
            } else if (d.createdAt) {
              const isoString = String(d.createdAt).includes('Z') 
                ? String(d.createdAt) 
                : String(d.createdAt).replace(' ', 'T') + 'Z';
              const diffHours = (new Date().getTime() - new Date(isoString).getTime()) / 3600000;
              isExpired = diffHours > 24;
            } else {
              isExpired = true;
            }
            return (
              <div key={d.id} className="flex justify-between items-center p-2 border-b dark:border-gray-600">
                <span className="flex items-center">
                  {d.code} - {d.discount}%
                  {isExpired ? (
                    <span className="ml-2 text-xs bg-red-100 text-red-600 px-2 py-1 rounded">Expirado</span>
                  ) : (
                    <span className="ml-2 text-xs bg-green-100 text-green-600 px-2 py-1 rounded">Ativo</span>
                  )}
                </span>
                <button 
                  onClick={() => handleDelete(d.id)}
                  className="text-red-500 hover:text-red-700"
                >
                  Remover
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
};
